<template>
  <div id="tour-dates-selector">
    <div class="box box-dropdown">
      <div class="box-content">
        <template v-if="loading">
          <div class="preloader"></div>
          <div class="ml-3">
            Секундочку..
          </div>
        </template>
        <template v-else-if="tour_dates.length == 0">
          <div>
            <b>Нет подходящих дат</b>
            <br>
            Похоже, что актуальные даты тура прошли, а новые не запланированы.
            <br>
            Свяжитесь с нами для уточнения информации.
          </div>
        </template>
        <template v-else>
          <guide-filter :guides="guides"
                        @filter="on_filtering"
          ></guide-filter>
          <div class="tour-dates--list-wrapper">
            <template v-for="(tour_date, i) in filtered_dates">
              <transition name="fade-simple">
                <div class="tour-date-btn"
                     @click="on_select_date(tour_date)"
                >
                  {{formatted_date(tour_date.attributes.date)}}
                  <discount-badge
                      :id_key="tour_date.id"
                      :discount="tour_date.attributes.discount"
                      :discount_type="tour_date.attributes.discount_type"
                      smart

                  >

                  </discount-badge>

                </div>
              </transition>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>

import moment from 'moment';
import GuideFilter from "./GuideFilter";
import DiscountBadge from "../shared/DiscountBadge";
export default {
  components: {DiscountBadge, GuideFilter},
  props: {
    tour_dates: Array,
    loading: Boolean,
  },
  data() {
    return {
      guides: [],
      selected_guide: undefined,
    }
  },
  computed: {
    filtered_dates(){
      if (this.selected_guide === undefined){
        return this.tour_dates;
      } else {
        return _.filter(this.tour_dates, {attributes:{guide_id: this.selected_guide.id}});
      }
    }
  },
  beforeMount() {
    this.fill_guides();
  },
  methods:{
    on_filtering(guide) {
      console.log(guide);
      this.$set(this, 'selected_guide', guide);
    },
    on_select_date(tour_date) {
      console.log('on_select_date');
      this.$emit('select_date', tour_date);
    },
    formatted_date(date){
      return moment(date).format('L')
    },
    fill_guides(){
      let guides = [];
      _.each(this.tour_dates, (td)=>{
        guides.push({
          id: td.attributes.guide_id,
          name: td.attributes.guide_name,
        })
      })
      this.$set(this, 'guides', _.uniqBy(guides, 'id'))
    }
  },

}
</script>
<style>
.tour-dates-buttons-wrapper{
  position: absolute;
}

</style>